import type { ComponentType } from 'react';

import { Grid } from '@interstate/components/Grid';

import { StyledTypography } from './styled.components';

const ROW_LABEL_BACKGROUND = '#f4f4f4';

type RowLabelCellProps<P extends object> = {
    label: string;
    bordered: boolean;
    cell: ComponentType<P>;
    unborderedMarginTop: string;
    cellProps?: Partial<P>;
    testId: string;
    baseHeight?: string;
};

const RowLabelCell = <P extends object>({
    label,
    bordered,
    cell: Cell,
    unborderedMarginTop,
    cellProps,
    testId,
    baseHeight = '80px'
}: RowLabelCellProps<P>) => {
    if (!bordered) {
        const isGrown = Boolean((cellProps as { $growToFit?: boolean } | undefined)?.$growToFit);
        return (
            <Grid
                xs={3}
                textAlign="center"
                data-testid={testId}
                sx={
                    isGrown
                        ? {
                              alignSelf: 'flex-start',
                              minHeight: baseHeight,
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center'
                          }
                        : undefined
                }
            >
                <StyledTypography className="large" style={{ color: 'black', marginTop: unborderedMarginTop }}>
                    {label}
                </StyledTypography>
            </Grid>
        );
    }

    const cellOwnProps = {
        xs: 3,
        className: ' payment-grid-item',
        sx: { background: ROW_LABEL_BACKGROUND },
        style: { justifyContent: 'center' },
        'data-testid': testId,
        ...cellProps
    } as unknown as P;

    return (
        <Cell {...cellOwnProps}>
            <StyledTypography className="large" style={{ color: 'black' }}>
                {label}
            </StyledTypography>
        </Cell>
    );
};

export default RowLabelCell;
